<template>
  <div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por descrição"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="enable">Status</label>
          <select v-model="query.enable" id="enable" class="form-control">
            <option value="true">Ativo</option>
            <option value="false">Inativo</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="ticket-day">Data inicial</label>
          <input v-model="query.startDate" type="date" id="ticket-day" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button class="btn btn-primary mt-1 mr-1" @click="openModal({}, true)">
          Novo
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-sm-12">

        <div class="row mt-4">
          <div class="col-md-12">
            <strong class="mr-3">
              {{infoTotalModels}}
            </strong>
          </div>
        </div>

        <Table
          :scrapingServices="scrapingServices"
          @deleteEntity="deleteEntity"
          @showEntity="showEntity"
          @editEntity="editEntity"
        />

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>

    <Modal v-model="showModal" v-if="currentScrapingService">
      <span slot="header">Novo</span>
      <Form
        :scrapingService="currentScrapingService"
        :editable="editable"
        @cancel="showModal = false"
        @saveEntity="saveEntity($event)"
      />
    </Modal>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import EntityProxy from '@/models/EntityProxy'
import Pagination from '@/components/shares/specialTag/Pagination'
import Form from './Form'

import Modal from '@/components/shares/specialTag/Modal'
import ModelMapper from '@/mixins/ModelMapper'
import Table from './Table'

import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
import { Filter } from '@/models/filter'

export default {
  components: { BadgeFilters, ChevronDownIcon, Form, Modal, Pagination, SearchIcon, Table },
  computed: {
    badgeFilters() {
      return [this.filterEndDate, this.filterStartDate]
    },
    scrapingServices() {
      return this.getModels || []
    },
  },
  created() {
    this.addOrderBy('createdAt')

    this.defaultModelSetting.updateQueryURL = true
    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data: () => ({
    currentScrapingService: null,
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    nameModel: 'TicketDescription',
    showModal: false,
    editable: false,
  }),
  methods: {
    deleteEntity(scrapingService) {
      if (!confirm('Tem certeza?'))
        return

      this.asyncTemplateDelete(scrapingService, {
        after: () => {
          this.$notify.add('Excluído com sucesso.')
          this.find()
        }
      })
    },
    buildPath() {
      return 'admin/maestro/scraping_services'
    },
    find() {
      this.asyncTemplateSelect()
    },
    openModal(scrapingService, editable) {
      this.currentScrapingService = EntityProxy.clone(scrapingService)
      this.showModal = true
      this.editable = editable
    },
    saveEntity(scrapingService) {
      this.asyncTemplateSave(scrapingService, {
        after: () => {
          this.$notify.add('Salvo com sucesso!')
          this.showModal = false
          this.find()
        }
      })
    },
    editEntity(scrapingService) {
      this.openModal(scrapingService, true)
    },
    showEntity(scrapingService) {
      this.openModal(scrapingService)
    },
  },
  mixins: [ModelMapper],
  name: 'Index',
  watch: {
    showModal(value) {
      if (!value)
        this.editable = false
    }
  }
}
</script>

<style scoped>
.fa-angle-right {
  transition: transform .2s;
  margin-left: 8px;
}
</style>